import React, { useEffect, useState } from "react"
import { FormControl, FormGroup, FormLabel, Modal, Button } from "react-bootstrap"
import TableCommponnent from "../../components/TableCommponnent"
import PageTitleBar from "../../components/PageTitleBar"
import { ReactComponent as ThumbsUp } from "../../assets/images/thumbsup.svg"
import { ReactComponent as ThumbsDown } from "../../assets/images/thumbsdown.svg"
import { ReactComponent as ApprovalModalImage } from "../../assets/images/image 12.svg"
import ApprovalStatusImage from "../../assets/images/image 12.png"
import formatText from "../../components/formatText"
import axiosInstance from "../../services/axiosInstance"
import Header from "../apprLyout/Topnav"
import Loader from "../../components/Loader"
import Sidenav from "../apprLyout/Sidenav"
import { useNavigate, useLocation } from "react-router-dom"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Invoice from "../../components/Invoice"
import Error from "../../components/Error"
import SessionExpired from "./sessionExpired"
import { ReactComponent as DownloadIcon } from "../../assets/images/downloadIcon.svg"
import { Info } from "lucide-react"
import { buildRouteQuery } from "../../utils/queryParams"

const INITIAL_CRITERIA = {
  q: "",
  po: "",
  grn: "",
  status: "all",
  from_date: null,
  to_date: null,
  min_total: "",
  max_total: "",
  order_by: "",
}

const AllInvoice = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const invoice = JSON.parse(localStorage.getItem("invoice"))
  const approvalCommentRequired = invoice?.workflow?.pending_approval_from === "accounts_payable"
  const roles = JSON.parse(localStorage.getItem("roles")) || []
  const isAccountsPayable = roles.includes("accounts_payable")
  const [selectedIds, setSelectedIds] = useState([])
  const [bulkAction, setBulkAction] = useState(false)
  const [invoiceData, setInvoiceData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [sessionExpired, setsessionExpired] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  const [total, setTotal] = useState(1)
  const [count, setCount] = useState(1)
  const [isSearching, setIsSearching] = useState(false)
  const token = localStorage.getItem("accessToken")
  const name = localStorage.getItem("name")
  const [totalPages, setTotalPages] = useState(Math.ceil(invoiceData?.length / itemsPerPage))
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentData = invoiceData?.slice(startIndex, endIndex)
  const [activeItemId, setActiveItemId] = useState(null)
  const [comment, setComment] = useState("")
  const [sign, setSign] = useState(null)
  const [hoveredAction, setHoveredAction] = useState(null)
  const [modalState, setModalState] = useState(false)
  const [approvalMessage, setApprovalMessage] = useState("")
  const [confirmationModalShow, setConfirmationModalShow] = useState(false)
  const [action, setAction] = useState(null)
  const [error, setError] = useState(null)
  // search criteria
  const [criteria, setCriteria] = useState({ ...INITIAL_CRITERIA })

  const getSignables = async (page, size) => {
    const roles = JSON.parse(localStorage.getItem("roles")) || []
    const isAdmin = roles.includes("admin")
    setLoading(true)

    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/approvals/v1/${
          isAdmin ? "any" : "get"
        }/invoice/all?page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      console.log(response.data.data.results, "I am the res")
      localStorage.setItem("responseData", JSON.stringify(response.data.data.results))
      setInvoiceData(response.data.data.results)
      setCount(response.data.data.count)
      const totalPages = Math.ceil(response.data.data.count / size)
      setTotalPages(totalPages)
      setTotal(response.data.data.count)
    } catch (error) {
      console.log(error, "PO fetching error.")
      const errorMessage =
        error?.response?.data?.detail || "Error Fetching PO Items"
          ? error?.response?.data?.detail
          : "Error Fetching PO"

      if (error?.response?.status === 401) {
        // Call handleLogout in case of 401 error
        // handleLogout(msalConfig, userName, navigate);
        setsessionExpired(true)
      } else {
        setError(errorMessage)
      }
    } finally {
      setLoading(false) // Hide loading indicator
    }
  }

  // Build query params helper
  const buildQueryParams = paramsObj => {
    const searchParams = new URLSearchParams()
    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        if (value instanceof Date) {
          searchParams.append(key, value.toISOString().split("T")[0])
        } else {
          searchParams.append(key, value)
        }
      }
    })
    return searchParams.toString()
  }

  // Helper function to convert date to CSV format (moved outside for efficiency)
  const csvConvertDate = dateString => {
    if (!dateString) return { date: "", time: "" }
    const date = new Date(dateString)
    const day = String(date.getUTCDate()).padStart(2, "0")
    const month = String(date.getUTCMonth() + 1).padStart(2, "0")
    const year = date.getUTCFullYear()
    const hours = String(date.getUTCHours()).padStart(2, "0")
    const minutes = String(date.getUTCMinutes()).padStart(2, "0")
    const seconds = String(date.getUTCSeconds()).padStart(2, "0")
    return {
      date: `${day}-${month}-${year}`,
      time: `${hours}:${minutes}:${seconds}`,
    }
  }

  const exportToCSV = async () => {
    try {
      setLoading(true)
      const countQuery = buildQueryParams({ ...criteria, page: 1, size: 1 })
      const countRes = await axiosInstance.get(`/approvals/v1/search/invoice?${countQuery}`)
      const totalCount = countRes.data.data.count || 0

      if (totalCount === 0) {
        setError("No data found")
        return
      }

      // Fetch all search results using the exact count
      const query = buildQueryParams({ ...criteria, page: 1, size: totalCount })
      const res = await axiosInstance.get(`/approvals/v1/download/invoice?${query}`)
      const download_url = res.data.data.download_url || []
      const filename = download_url.split("/").pop()
      // window.open(download_url, '_blank');
      // Download the CSV
      const link = document.createElement("a")
      link.setAttribute("href", download_url)
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error("Export error", error)
      setError("Error exporting data. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const fetchSearchResults = async (page, size, searchCriteria = null) => {
    setLoading(true)
    const criteriaToUse = searchCriteria || criteria
    const query = buildQueryParams({ ...criteriaToUse, page, size })
    try {
      const res = await axiosInstance.get(`/approvals/v1/search/invoice?${query}`)
      setInvoiceData(res.data.data.results)
      setCount(res.data.data.count)
      setTotal(Math.ceil(res.data.data.count / size))
    } catch (error) {
      console.error("Search error", error)
      setError("Error fetching search results")
    } finally {
      setLoading(false)
    }
  }

  const handleCriteriaChange = e => {
    const { name, value } = e.target
    setCriteria(prev => ({ ...prev, [name]: value }))
  }

  const handleSearchSubmit = e => {
    e.preventDefault()
    setIsSearching(true)
    setPage(1)

    // Update URL with search criteria
    const searchParams = new URLSearchParams()
    searchParams.set("page", "1")
    if (size !== 10) {
      searchParams.set("page_size", size.toString())
    }

    // Add search criteria to URL
    Object.entries(criteria).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        if (value instanceof Date) {
          searchParams.set(key, value.toISOString().split("T")[0])
        } else {
          searchParams.set(key, value)
        }
      }
    })

    navigate(`${location.pathname}?${searchParams.toString()}`)
    fetchSearchResults(1, size)
  }

  const handleResetSearch = () => {
    setCriteria({ ...INITIAL_CRITERIA })
    setIsSearching(false)
    setPage(1)
    setCurrentPage(1)

    const params = new URLSearchParams()
    params.set("page", "1")
    const pageSizeParam = size || 10
    params.set("page_size", pageSizeParam.toString())

    navigate(`${location.pathname}?${params.toString()}`)
  }

  const handlePrevPage = () => {
    navigate(-1)
    // if (currentPage > 1) {
    // 	setCurrentPage(currentPage - 1);
    // }
  }

  const handleChangeItemsPerPage = e => {
    const selectedValue = parseInt(e.target.value)
    setItemsPerPage(selectedValue)
    setCurrentPage(1) // Reset to the first page when changing items per page
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handleApprovalPreviousPage = itemId => {
    console.log(activeItemId, "itemID")
    // console.log('itemIDSDFFSRFAS')
    navigate(-1)
  }

  const handleButtonClick = itemId => {
    setActiveItemId(itemId)
    localStorage.setItem("invoice", JSON.stringify(itemId))
  }

  const handleToggleRow = id => {
    setSelectedIds(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]))
  }

  const handleToggleAll = eligibleIds => {
    setSelectedIds(prev => {
      const allSelected = eligibleIds.length > 0 && eligibleIds.every(id => prev.includes(id))
      return allSelected
        ? prev.filter(id => !eligibleIds.includes(id))
        : [...new Set([...prev, ...eligibleIds])]
    })
  }

  const handleParentModalShow = action => {
    setAction(action)
    setBulkAction(false)
    setModalState(true)
  }

  const handleBulkApprove = () => {
    setAction("approve")
    setBulkAction(true)
    setModalState(true)
  }

  const handleModalConfirm = async () => {
    setModalState(false)
    setLoading(true)
    if (bulkAction) {
      await signSignables(selectedIds, action === "approve", comment)
    } else {
      await signSignables([invoice.id], action === "approve", comment)
    }
  }

  const handleCloseConfirmationModal = () => {
    setConfirmationModalShow(false)
    if (error) {
      setError("")
      setApprovalMessage("")
      return
    }
    if (action === "approve") {
      window.location.href = `/approval/all?${buildRouteQuery({ page: 1, status: "pending" })}`
    } else if (action === "decline") {
      window.location.href = `/approval/all?${buildRouteQuery({ page: 1, status: "declined" })}`
    } else {
      window.location.href = "/approval/all"
    }
  }

  const signSignables = async (objectIds, approved, commentText) => {
    try {
      if (!objectIds || objectIds.length === 0) {
        throw new Error("No invoice selected.")
      }

      setError("")
      setApprovalMessage("")

      const body = { object_ids: objectIds, approved }
      if (commentText !== undefined) {
        body.comment = commentText
      }

      await axiosInstance.post("/approvals/v1/sign/invoice", body)

      setApprovalMessage(
        `${objectIds.length > 1 ? "Invoices" : "Invoice"} ${approved ? "Approved" : "Declined"} Successfully`,
      )
      setConfirmationModalShow(true)
    } catch (error) {
      console.log(error, "Error during the invoice signing process.")

      if (error?.response?.status === 401) {
        setsessionExpired(true)
      } else {
        const errorMessage = String(error) || "Error with the request"
        setError(errorMessage)
        setApprovalMessage(errorMessage)
      }
      setConfirmationModalShow(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const pageParam = params.get("page")
    const pageSizeParam = params.get("page_size")

    const newPage = pageParam ? Number(pageParam) : 1
    const newPageSize = pageSizeParam ? Number(pageSizeParam) : 10

    setPage(newPage)
    setSize(newPageSize)

    // Check if there are search criteria in URL
    const hasSearchCriteria =
      params.get("q") ||
      params.get("po") ||
      params.get("grn") ||
      params.get("from_date") ||
      params.get("to_date") ||
      params.get("min_total") ||
      params.get("max_total") ||
      (params.get("status") && params.get("status") !== "all")

    if (hasSearchCriteria) {
      // Restore search criteria from URL
      const restoredCriteria = {
        q: params.get("q") || "",
        po: params.get("po") || "",
        grn: params.get("grn") || "",
        status: params.get("status") || "all",
        from_date: params.get("from_date") ? new Date(params.get("from_date")) : null,
        to_date: params.get("to_date") ? new Date(params.get("to_date")) : null,
        min_total: params.get("min_total") || "",
        max_total: params.get("max_total") || "",
        order_by: params.get("order_by") || INITIAL_CRITERIA.order_by,
      }
      setCriteria(restoredCriteria)
      setIsSearching(true)
      fetchSearchResults(newPage, newPageSize, restoredCriteria)
    } else {
      // Check if initial criteria has non-default values (e.g., status !== "all")
      const hasInitialCriteria =
        criteria.status !== "all" || criteria.q || criteria.po || criteria.grn

      if (hasInitialCriteria) {
        setIsSearching(true)
        fetchSearchResults(newPage, newPageSize, criteria)
      } else {
        setIsSearching(false)
        getSignables(newPage, newPageSize)
      }
    }
  }, [location.search])

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages)
    }
  }, [currentPage, totalPages])

  return (
    <>
      {loading && <Loader />}
      {sessionExpired ? (
        <SessionExpired />
      ) : (
        <div>
          <Header />

          <div className="flex min-h-screen pb-16 ">
            <div className=" hidden md:block">
              <Sidenav />
            </div>
            <div className="content md:w-[80%] w-full md:ml-[20%] lg:w-[86%] lg:ml-[14%] px-3">
              <PageTitleBar
                title={"All Invoices"}
                onPrevPage={handleApprovalPreviousPage}
                itemId={activeItemId}
              />
              {/* Search & Filter Form */}
              <form
                className="bg-white p-4 mb-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 rounded-md"
                onSubmit={handleSearchSubmit}
              >
                <input
                  type="text"
                  name="q"
                  placeholder="Search..."
                  value={criteria.q}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                />
                <input
                  type="text"
                  name="po"
                  placeholder="PO ID"
                  value={criteria.po}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                />
                <input
                  type="text"
                  name="grn"
                  placeholder="GRN ID"
                  value={criteria.grn}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                />
                <select
                  name="status"
                  value={criteria.status}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                >
                  <option value="all">All</option>
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="approved">Approved</option>
                  <option value="declined">Declined</option>
                </select>
                <select
                  name="order_by"
                  value={criteria.order_by}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                >
                  <option value="" disabled>
                    Sort by
                  </option>
                  <option value="-date_created">Newest first</option>
                  <option value="date_created">Oldest first</option>
                </select>
                <div className="flex gap-2 items-center">
                  <DatePicker
                    selected={criteria.from_date}
                    onChange={date => setCriteria(p => ({ ...p, from_date: date }))}
                    placeholderText="From date"
                    className="border p-2 text-sm w-full"
                  />
                  <DatePicker
                    selected={criteria.to_date}
                    onChange={date => setCriteria(p => ({ ...p, to_date: date }))}
                    placeholderText="To date"
                    className="border p-2 text-sm w-full"
                  />
                </div>
                <input
                  type="number"
                  name="min_total"
                  placeholder="Min total"
                  value={criteria.min_total}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                />
                <input
                  type="number"
                  name="max_total"
                  placeholder="Max total"
                  value={criteria.max_total}
                  onChange={handleCriteriaChange}
                  className="border p-2 text-sm"
                />
                <div className="flex gap-2">
                  <button type="submit" className="bg-[#027C94] text-white px-4 py-2 rounded-md">
                    Search
                  </button>
                  <button
                    type="button"
                    onClick={handleResetSearch}
                    className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md"
                  >
                    Reset
                  </button>
                </div>
              </form>
              <button
                className="flex self-end w-[90%]  mx-4 md:w-48 text-white rounded-md mb-4 bg-[#067203] items-center justify-center font-medium text-base px-4 gap-3 py-2"
                onClick={exportToCSV}
              >
                <DownloadIcon />
                <span>Export csv</span>
              </button>
              <div>
                {activeItemId ? (
                  <div className="flex flex-col md:flex-row gap-3 overflow-x-auto">
                    {/* Invoice Container */}
                    <div
                      className="w-full md:w-[70%] bg-white flex flex-col py-4 overflow-auto"
                      id="pdf"
                    >
                      <Invoice receipt={invoice} />
                    </div>

                    {/* Approval Status and Form */}
                    <div className="w-full md:w-[30%] rounded-lg">
                      <p className="approval-card-title text-center py-2 rounded-t-md bg-gray-100 font-semibold">
                        Status: Awaiting Payment Approval
                      </p>
                      <div className="card p-4 space-y-3">
                        <FormGroup>
                          <FormLabel className="text-lg">Role</FormLabel>
                          <FormControl
                            className="pl-2 bg-gray-50 text-sm py-2"
                            placeholder="Role"
                            value={formatText(invoice.workflow.pending_approval_from)}
                            readOnly
                          />
                          <FormControl
                            className="mt-3 pl-2 bg-gray-50 text-sm py-2"
                            placeholder="Name"
                            value={name}
                          />
                          <FormLabel className="mt-3 flex items-center gap-2">
                            Comments
                            <div className="group relative">
                              <Info size={16} className="text-gray-500 cursor-help" />
                              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                                Comments entered here will reflect in the header text in ByD
                              </div>
                            </div>
                          </FormLabel>
                          <FormControl
                            as="textarea"
                            rows={4}
                            placeholder="Comments"
                            className="bg-gray-50 text-sm py-2 resize-none"
                            onChange={e => {
                              if (e.target.value.length <= 40) {
                                setComment(e.target.value)
                              }
                            }}
                            value={comment}
                            maxLength={40}
                          />
                          <div className="text-xs text-gray-500 mt-1 mb-2.5">
                            {comment.length}/40 characters
                          </div>
                        </FormGroup>

                        {/* Approval/Decline Buttons */}
                        <div className="flex justify-between mx-4 my-2 space-x-3">
                          <button
                            className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-white bg-green-600 rounded hover:bg-green-700 transition"
                            onClick={() => {
                              if (approvalCommentRequired && comment === "") {
                                setHoveredAction("approve")
                                setShowMessage(true)
                              } else {
                                handleParentModalShow("approve")
                              }
                            }}
                            onMouseEnter={() => {
                              if (approvalCommentRequired && comment === "") {
                                setHoveredAction("approve")
                                setShowMessage(true)
                              }
                            }}
                            onMouseLeave={() => {
                              setHoveredAction(null)
                              setShowMessage(false)
                            }}
                          >
                            <ThumbsDown className="text-lg" />
                            <span>Approve</span>
                          </button>

                          <button
                            className={`flex-1 flex items-center justify-center gap-1 px-3 py-2 text-white bg-red-500 rounded hover:bg-red-600 transition`}
                            onClick={() => {
                              if (comment === "") {
                                setHoveredAction("decline")
                                setShowMessage(true)
                              } else {
                                handleParentModalShow("decline")
                              }
                            }}
                            onMouseEnter={() => {
                              if (comment === "") {
                                setHoveredAction("decline")
                                setShowMessage(true)
                              }
                            }}
                            onMouseLeave={() => {
                              setHoveredAction(null)
                              setShowMessage(false)
                            }}
                          >
                            <ThumbsUp className="text-lg" />
                            <span>Decline</span>
                          </button>
                        </div>

                        {showMessage && comment === "" && (
                          <p className="text-red-600 text-sm mt-2">
                            Comment is required to {hoveredAction} this invoice
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full">
                    {!isAccountsPayable && selectedIds.length > 0 && (
                      <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-md px-4 py-2 mb-3">
                        <span className="text-sm text-blue-900">
                          {selectedIds.length} invoice{selectedIds.length > 1 ? "s" : ""} selected
                        </span>
                        <div className="flex gap-2">
                          <button
                            type="button"
                            className="px-3 py-1.5 text-sm text-white bg-green-600 rounded hover:bg-green-700"
                            onClick={handleBulkApprove}
                          >
                            Approve Selected
                          </button>
                        </div>
                      </div>
                    )}
                    <TableCommponnent
                      data={currentData}
                      recent_invoice={false}
                      currentPage={currentPage}
                      handleChangeItemsPerPage={handleChangeItemsPerPage}
                      itemsPerPage={itemsPerPage}
                      handlePrevPage={handlePrevPage}
                      handleNextPage={handleNextPage}
                      totalPages={totalPages}
                      onButtonClick={handleButtonClick}
                      complete={true}
                      allInvoices={true}
                      total={total}
                      count={count}
                      size={size}
                      page={page}
                      isSearching={isSearching}
                      searchCriteria={criteria}
                      selectable={!isAccountsPayable}
                      selectedIds={selectedIds}
                      onToggleRow={handleToggleRow}
                      onToggleAll={handleToggleAll}
                    />
                  </div>
                )}

                {/* Modal for Confirmation */}
                <Modal show={modalState} onHide={() => setModalState(false)} centered>
                  <Modal.Body>
                    <div className="flex flex-col items-center justify-center">
                      <ApprovalModalImage />
                      <p>
                        Are you sure you want to {action}{" "}
                        {bulkAction ? `${selectedIds.length} invoices` : "this invoice"}?
                      </p>
                      <div className="flex gap-3 my-4">
                        <Button
                          style={{
                            backgroundColor: "#12AF2B",
                            borderRadius: "2px",
                            width: "120px",
                            borderColor: "#12AF2B",
                          }}
                          onClick={handleModalConfirm}
                        >
                          Yes
                        </Button>
                        <Button
                          style={{
                            backgroundColor: "#C00E19",
                            borderRadius: "2px",
                            width: "120px",
                            borderColor: "#C00E19",
                          }}
                          onClick={() => setModalState(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>

                {error ? (
                  <Error
                    message={approvalMessage}
                    show={confirmationModalShow}
                    handleShow={handleCloseConfirmationModal}
                  />
                ) : (
                  <Modal show={confirmationModalShow} onHide={handleCloseConfirmationModal} centered>
                    <Modal.Body>
                      <div className="flex flex-col items-center justify-center">
                        <img src={ApprovalStatusImage} alt="Approval Status" />
                        <p className="approval-status-message py-2">{approvalMessage}</p>
                        <Button
                          className="mb-4"
                          style={{
                            backgroundColor: "#12AF2B",
                            borderRadius: "2px",
                            width: "120px",
                          }}
                          onClick={handleCloseConfirmationModal}
                        >
                          Close
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <Footer/>    */}
    </>
  )
}

export default AllInvoice
